import React from 'react'
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import {withRouter} from 'react-router';
import Redirect from "../../helpers/Redirect";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import Grid from "@material-ui/core/Grid";
import ValidateSizeFile from "../../helpers/ValidateSizeFile";
import AppToast from "../../ui/AppToast";
import {getFileExtension, getFormData} from "../../helpers/Helpers";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import {Card} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CKEditor from "react-ckeditor-component";
import DocumentacionPaquete from "./DocumentacionPaquete";
import {confirmAlert} from "react-confirm-alert";

class DocumentacionSolicitud extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            solicitud: null,
            solicitudPasoID: null,
            descripcion: '',
            documentos: [],
            documentosPorPaquete: [],
            validarMinimoPaquete: null,
            message: '',
        };

        this.handleChangeFilesDinamic = this.handleChangeFilesDinamic.bind(this);
        this.adicionarPaquete = this.adicionarPaquete.bind(this);
        this.borrarPaquete = this.borrarPaquete.bind(this);
        this.validarDocumentacionPaquete = this.validarDocumentacionPaquete.bind(this);
        this.configurarEnvioDocumentosPaquete = this.configurarEnvioDocumentosPaquete.bind(this);
        this.verArchivo = this.verArchivo.bind(this);
        this.borrarArchivo = this.borrarArchivo.bind(this);
    }

    async componentDidMount() {
        const solicitudID = this.props.match.params.solicitudID;
        this.getSolicitud(solicitudID);
    }

    getSolicitud = async (solicitudID) => {
        const response = await Api.get(`${Env.UrlBackendCuentaNueva}/solicitud/show/${solicitudID}`);
        this.setState({
            solicitud: response.data,
            documentos: response.data.documentos,
            documentosPorPaquete: response.data.documentosPorPaquete,
            validarMinimoPaquete: response.validarMinimoPaquete,
            solicitudPasoID: response.data.solicitud_paso_id,
            message: '¡Por el momento no tiene pendiente documentos por adjuntar!'
        });
    }

    adicionarPaquete = (data) => {
        const documentosPorPaquete = this.state.documentosPorPaquete;
        documentosPorPaquete.push(data);
        this.setState({
            documentosPorPaquete
        });
    }

    borrarPaquete = (numeroPaquete, validarMinimoPaquete) => {
        const documentosPorPaquete = this.state.documentosPorPaquete;
        for (let i = 0; i < documentosPorPaquete.length; i++) {
            if (documentosPorPaquete[i].numero_paquete === numeroPaquete) {
                documentosPorPaquete.splice(i, 1);
            }
        }
        this.setState({
            documentosPorPaquete,
            validarMinimoPaquete
        });
    }

    //subir archvivo al servidor
    handleChangeFilesDinamic = (e, val, validaPaquete) => {
        const selectorFiles = e.target.files;
        let file = null;
        if (selectorFiles.length > 0) {
            file = selectorFiles[0];
        } else {
            return;
        }

        if (!ValidateSizeFile(file, val?.documento?.tamanio)) {
            AppToast(`El tamaño permitido es de ${val?.documento?.tamanio} megas`, false);
            e.target.value = '';
            return false;
        }

        const fileExtension = getFileExtension(file.name);
        const extensiones = val?.documento?.tipos.split(",");
        if (!extensiones.includes(fileExtension)) {
            AppToast(`Solo se puede adjuntar documentos de tipo: ${val?.documento?.tipos}.`, false);
            e.target.value = '';
            return false;
        }

        val.archivo = file;

        if(validaPaquete){
            this.subirArchivoIndividual(file, val);
        }
    }

    subirArchivoIndividual = async (file, val) => {
        let newParams = {
            ...val,
            [`documentacion_${val.id}_paquete_${val.numero_paquete}`]:(file),
            [`archivo`]: (file),
            [`tipo`]: (val.documento.tipos),
        };

        const formData = getFormData(newParams);
        const data = await Api.postWithoutFormData(`${Env.UrlBackendCuentaNueva}/solicitud-paso-documento/envio-individual`, formData);
        if (data.success) {
            AppToast(data.message, true);
        } else {
            AppToast(data.message, false);
        }
    }

    guardar = () => {

        // if (!this.validate()) {
        //     return;
        // }

        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h3>¿Desea finalizar el proceso?</h3>
                        <div style={{textAlign: 'left'}}>
                            <p><b>SI: </b> Si selecciona <b>SI</b> se guardará la información y finalizará el proceso.
                            </p>
                            <p><b>NO: </b> Si selecciona <b>NO</b> se guardará la información pero puede seguir
                                editandola más adelante.</p>
                        </div>
                        <button onClick={async () => {

                            this.apiGuardar('0');
                            onClose();

                        }}
                        >
                            NO
                        </button>
                        <button className='custom-ui-btn-si' onClick={async () => {

                            onClose();
                            
                            if (!this.validate()) {
                                return;
                            }

                            confirmAlert({
                                customUI: ({onClose}) => {
                                    return (
                                        <div className='custom-ui'>
                                            <h3>¿Está seguro(a) de finalizar el proceso?</h3>
                                            <button onClick={onClose}>NO</button>
                                            <button className='custom-ui-btn-si' onClick={async () => {



                                                this.apiGuardar('1');
                                                onClose();

                                            }}>SI
                                            </button>
                                        </div>
                                    );
                                }
                            });

                        }}>SI
                        </button>
                    </div>
                );
            }
        });
    }

    apiGuardar = async (finalizar) => {
        // Asigno la documentacion requerida
        let params = {
            finalizarProceso: finalizar,
            solicitudID: this.props.match.params.solicitudID,
            solicitudPasoID: this.state.solicitudPasoID,
            descripcion: this.state.descripcion,
            documentos: JSON.stringify(this.state.documentos),
            documentosPorPaqute: JSON.stringify(this.state.documentosPorPaquete),
        };
        // Configuro la documentacion normal
        for (let value of this.state.documentos) {
            if (value.archivo) {
                params = {
                    ...params,
                    [`documentacion_${value.id}`]: value.archivo,
                };
            }
        }
        // Configuro la documentacion por paquetes
        // for (let documentos of this.state.documentosPorPaquete) {
        //     params = this.configurarEnvioDocumentosPaquete(documentos.numero_paquete, documentos.data, params);
        // }
        const formData = getFormData(params);
        const data = await Api.postWithoutFormData(`${Env.UrlBackendCuentaNueva}/solicitud-paso-documento/envio-documentos`, formData);
        if (data.success) {
            AppToast(data.message, true);
            this.setState({
                url: '/new-account-list'
            });
        } else {
            AppToast(data.message, false);
        }
    }

    validate = () => {

        // --- Valido que adjunte toda la documentacion obligatoria
        for (let value of this.state.documentos) {
            if (value.requerido === '1') {
               /* if (!value.archivo && !value.url_documentos) {
                    AppToast(`Debe adjuntar el archivo: ${value.documento.nombre}`, false);
                    return false;
                }*/ //QUITAR COMENTARIOS
            }
        }

        // --- Valido que agregue la cantidad de paquetes mínimos
        /*if (Number(this.state.solicitud.tipo.minimo_paquetes) > 0) {
            if (this.state.documentosPorPaquete.length < Number(this.state.solicitud.tipo.minimo_paquetes)) {
                AppToast(`Debe agregar mínimo ${this.state.solicitud.tipo.minimo_paquetes} paquetes.`, false);
                return false;
            }
        }*/

        if (this.state.validarMinimoPaquete) {
            if (this.state.documentosPorPaquete.length < Number(this.state.solicitud.tipo.minimo_paquetes)) {
                AppToast(`Debe agregar mínimo ${this.state.solicitud.tipo.minimo_paquetes} paquetes.`, false);
                return false;
            }
        }

        // --- Valido que adjunte toda la documentacion por paquetes obligatoria
        for (let documentos of this.state.documentosPorPaquete) {
            if (!this.validarDocumentacionPaquete(documentos.data)) {
                return false;
            }
        }

        return true;
    }

    validarDocumentacionPaquete = (data) => {
        for (let value of data) {
            if (value.requerido === '1') {
                if (!value.archivo && !value.url_documentos) {
                    AppToast(`Debe adjuntar el archivo: ${value.documento.nombre} del Paquete No. ${value.numero_paquete}`, false);
                    return false;
                }
            }
        }

        return true;
    }

    configurarEnvioDocumentosPaquete = (numeroPaquete, data, params) => {
        let newParams = params;
        for (let value of data) {
            if (value.archivo) {
                newParams = {
                    ...newParams,
                    [`documentacion_${value.id}_paquete_${numeroPaquete}`]: value.archivo,
                };
            }
        }
        return newParams;
    }

    configurarEnvioDocumentosIndividual = (numeroPaquete, value, params) => {
        console.log(params);
        let newParams = params;
        // for (let value of data) {
            if (value.archivo) {
                newParams = {
                    ...newParams,
                    [`documentacion_${value.id}_paquete_${numeroPaquete}`]: value.archivo,
                };
            }
        // }
        return newParams;
    }

    verArchivo = (documento) => {
        const url = documento.url_documentos;
        window.open(Env.UrlPublicFilesCuentaNueva + url);
    }

    borrarArchivo = (documento) => {

        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <p>¿Está seguro(a) de borrar el archivo: <b>{documento.documento.nombre}</b>?
                            <br/><br/> Esta acción no se puede reversar.</p>
                        <button onClick={onClose}>No</button>
                        <button className='custom-ui-btn-si' onClick={async () => {

                            const params = {
                                solicitudPasoDocumentoID: documento.id,
                                url: documento.url_documentos,
                            };
                            const response = await Api.post(`${Env.UrlBackendCuentaNueva}/documento-paquete/borrar-archivo`, params);
                            if (response.success) {
                                AppToast(response.message, true);
                                documento.url_documentos = null;
                                this.forceUpdate();
                            } else {
                                AppToast(response.message, false);
                            }

                            onClose();
                        }}
                        >
                            Si
                        </button>
                    </div>
                );
            }
        });
    }

    onChangeCkEditor = (evt) => {
        const newContent = evt.editor.getData();
        this.setState({
            descripcion: newContent
        });
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <Redirect url={this.state.url}/>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'new-account-list',
                            label: 'Listado de cuentas nuevas'
                        }

                    ]}
                    actual={'Adjuntar Documentación Solicitud: ' + (this.state.solicitud?.radicado ? this.state.solicitud?.radicado : '')}
                />

                <h2>
                    <span>Adjuntar Documentación Solicitud: <span
                        style={{color: '#E37222'}}>{this.state.solicitud?.radicado}</span></span>
                </h2>

                <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}}>
                    <Card>
                        <table className='custom-table'>
                            <tbody>
                            <tr>
                                <th style={{width: '20%'}}>Tipo</th>
                                <td style={{width: '30%'}}>{this.state.solicitud?.tipo?.nombre}</td>
                                <th style={{width: '20%'}}>Nombre del proyecto</th>
                                <td style={{width: '30%'}}>{this.state.solicitud?.nombre_proyecto}</td>
                            </tr>
                            <tr>
                                <th>Zona</th>
                                <td>{this.state.solicitud?.zona?.nombre}</td>
                                <th>Municipio</th>
                                <td>{this.state.solicitud?.municipio?.nombre}</td>
                            </tr>
                            <tr>
                                <th>Dirección</th>
                                <td colSpan={3}>{this.state.solicitud?.direccion}</td>
                            </tr>
                            <tr>
                                <th>Propietario</th>
                                <td style={{textAlign: 'left'}}>
                                    {this.state.solicitud?.usuario?.numero_documento} <br/>
                                    {this.state.solicitud?.usuario?.full_nombre}
                                </td>
                                <th>Electricista</th>
                                <td style={{textAlign: 'left'}}>
                                    {this.state.solicitud?.electricista?.numero_documento} <br/>
                                    {this.state.solicitud?.electricista?.full_nombre}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        {
                            (this.state.documentos.length > 0 || this.state.documentosPorPaquete.length > 0) ?

                                <>

                                    <div style={{textAling: 'center', marginTop: '30px'}}>
                                        <span style={{
                                            border: '1px solid #0098DB',
                                            padding: '10px',
                                            borderRadius: '10px',
                                            color: '#0098DB'
                                        }}>

                                            <Icon color='primary' style={{
                                                padding: '5px',
                                                display: 'inline-block',
                                                verticalAlign: 'middle'
                                            }}>info</Icon>

                                            Recuerde que tiene plazo hasta: <b>{this.state.solicitud?.solicitud_paso?.maxima_fecha_entrega}</b> para enviar la documentación.
                                        </span>
                                    </div>

                                    <fieldset style={{marginTop: '20px'}}>
                                        <legend style={{textAlign: 'left'}}>Adjuntar documentación</legend>

                                        <div style={{marginBottom: '20px', fontWeight: 'bold'}}>
                                        <span>¡Puede descargar los formatos dando clic en el siguiente
                                            <a target='_blank'
                                               rel="noopener noreferrer"
                                               href='https://www.electrohuila.com.co/tramites-clientes/'> enlace</a>!
                                        </span>
                                        </div>

                                        <Grid container spacing={2}>

                                            {this.state.documentos.map((val, index) => {

                                                if (val.url_documentos) { // Si ya tiene un documento adjunto
                                                    return (
                                                        <Grid item xs={12} sm={6} key={index}>
                                                            <div style={{
                                                                border: '1px solid #ccc',
                                                                borderRadius: '5px',
                                                                marginBottom: '10px'
                                                            }}>
                                                                <label style={{fontSize: '11px'}}>
                                                                    {val?.documento?.nombre}

                                                                    <span style={{
                                                                        color: '#4caf50',
                                                                        marginLeft: '5px',
                                                                        fontSize: '20px',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                                    &#10003;
                                                                                </span>

                                                                </label>

                                                                <div style={{padding: '10px'}}>

                                                                    <Button
                                                                        variant="contained"
                                                                        color="secondary"
                                                                        size="small"
                                                                        startIcon={<Icon>visibility</Icon>}
                                                                        style={{
                                                                            marginRight: '10px'
                                                                        }}
                                                                        onClick={() => {
                                                                            this.verArchivo(val)
                                                                        }}>
                                                                        Ver
                                                                    </Button>

                                                                    <Button
                                                                        variant="contained"
                                                                        color="secondary"
                                                                        size="small"
                                                                        startIcon={<Icon>delete</Icon>}
                                                                        style={{
                                                                            marginRight: '10px',
                                                                            background: '#f44336'
                                                                        }}
                                                                        onClick={() => {
                                                                            this.borrarArchivo(val)
                                                                        }}>
                                                                        Borrar
                                                                    </Button>
                                                                </div>

                                                            </div>
                                                        </Grid>
                                                    );

                                                } else { // Si NO tiene un documento adjunto
                                                    return (
                                                        <Grid item xs={12} sm={6} key={index}>
                                                            <div style={{
                                                                border: '1px solid #ccc',
                                                                borderRadius: '5px',
                                                                marginBottom: '10px'
                                                            }}>
                                                                <label
                                                                    style={{fontSize: '11px'}}>{val?.documento?.nombre}
                                                                    <span className='file-obligatorio'>
                                                                    {val.requerido === '1' ? ' * ' : ''}
                                                                </span>
                                                                </label>
                                                                <input type="file"
                                                                       style={{padding: '10px'}}
                                                                       onChange={(e) => this.handleChangeFilesDinamic(e, val, 0)}/>

                                                                <Alert severity="info" style={{textAlign: 'left'}}>
                                                                    {
                                                                        val?.documento?.link_formato ?
                                                                            <span>
                                                                                * Descargar Formato &nbsp;
                                                                                <a rel="noopener noreferrer"
                                                                                   href={val.documento.link_formato}
                                                                                   target='_blank'>aquí</a>
                                                                            </span>
                                                                            : null
                                                                    }
                                                                    {
                                                                        val?.documento?.descripcion_formato ?
                                                                            <span>* {val?.documento?.descripcion_formato}</span>
                                                                            : null
                                                                    }
                                                                    * El tamaño máximo permitido es
                                                                    de {val?.documento?.tamanio} megas<br/>
                                                                    * Extensiones permitidas: {val?.documento?.tipos}
                                                                </Alert>

                                                            </div>
                                                        </Grid>
                                                    );
                                                }
                                            })}

                                        </Grid>

                                        <DocumentacionPaquete
                                            solicitudPasoID={this.state.solicitudPasoID}
                                            documentosPorPaquete={this.state.documentosPorPaquete}
                                            minimoPaquetes={this.state.solicitud.tipo.minimo_paquetes}

                                            handleChangeFilesDinamic={this.handleChangeFilesDinamic}
                                            adicionarPaquete={this.adicionarPaquete}
                                            borrarPaquete={this.borrarPaquete}
                                            validarDocumentacionPaquete={this.validarDocumentacionPaquete}
                                            configurarEnvioDocumentosPaquete={this.configurarEnvioDocumentosPaquete}
                                            verArchivo={this.verArchivo}
                                            borrarArchivo={this.borrarArchivo}
                                        />

                                        <Grid item xs={12}>
                                            <p style={{textAlign: 'left', fontWeight: 'bold'}}>Agregar observación</p>
                                            <CKEditor
                                                activeClass="p10"
                                                content={this.state.descripcion}
                                                events={{
                                                    "change": this.onChangeCkEditor
                                                }}
                                            />
                                        </Grid>

                                    </fieldset>

                                </>
                                : null
                        }

                    </Card>

                    {
                        (this.state.documentos.length > 0 || this.state.documentosPorPaquete.length > 0) ?
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                startIcon={<Icon>save</Icon>}
                                style={{margin: '10px'}}
                                onClick={this.guardar}
                            >
                                Guardar
                            </Button>
                            : <h4>{this.state.message}</h4>
                    }

                </div>

            </div>
        );
    }
}

export default withRouter(DocumentacionSolicitud)
